import { render } from "./SmIdeaPlanIcon.vue?vue&type=template&id=32024c98&scoped=true"
const script = {}

import "./SmIdeaPlanIcon.vue?vue&type=style&index=0&id=32024c98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32024c98"]])

export default __exports__